import { CalendlyExpert } from "@/features/experts/types/CalendlyExpert";
import Expert from "@/features/experts/types/Expert";
import { handleExpertRole } from "@/utils/Functions";
import { ExpertGender } from "../types/ExpertGender";
import { ExpertGenderRole } from "../types/ExpertGenderRole";

/**
 * Creates an Expert object from a CalendlyExpert.
 * @param expert - The selected expert.
 * @returns A formatted Expert object.
 */
export const createExpertFromCalendlyExpert = (expert: CalendlyExpert): Expert => {
    return {
        id: expert.id,
        position: expert.data.sex === ExpertGender.Male ? ExpertGenderRole.Dott : ExpertGenderRole.Dottssa,
        name: expert.data.name,
        familyName: expert.data.family_name,
        role: handleExpertRole(expert.role),
        skills: expert.tags,
        summary: expert.data.bio,
        avatar: expert.calendly_data.calendly_user.avatar_url,
    };
};